import React from "react";
export default function CourseItem({
	primary_content_topic: { name: contentTopic = "" } = {},
	eventId,
	eventName: title,
	eventDescription: summary = null,
}) {
  summary = summary.replace('&nbsp;','').replace('&amp;','&');
  title = title.replace('&nbsp;','').replace('&amp;','&');
	return (
		<div className="mb-8 grid md:grid-cols-3 gap-4">
			<div className="md:col-span-2">
				{!!contentTopic ? (
					<span className="text-primary text-xs uppercase">{contentTopic}</span>
				) : null}
				<h3 className="block mt-2 mb-4 text-black text-xl no-underline font-bold">
					{title}
				</h3>
				{!!summary ? <div className="text-coolGray-400">{summary}</div> : null}
			</div>
			<div className="md:col-span-1 md:self-center md:justify-self-center">
				<a
					href={`https://members.nada.org/register-now?id=${eventId}`}
					className="button bg-primary text-white"
				>
					Enroll Now <span className="sr-only"> in course: {title}</span>
				</a>
			</div>
		</div>
	);
}
